module.exports = __webpack_public_path__ + "img/section-invalid.f8881858.png";